/* eslint-disable no-mixed-spaces-and-tabs */
import { Box, Stack, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import DealTable from '@/components/tables/DealTable';
import { useDispatch } from 'react-redux';
import { setSelected } from '@/features/table/dealsTableSlice';
import InsightPolicyTable from '@/components/tables/InsightPolicyTable';
import InsightDebtorsTable from '@/components/tables/InsightDebtorsTable';
import DebtorsTable from '@/components/tables/DebtorsTable';
import { useFeatureFlagContext } from '@/context/featureFlagContext';

export const DealTableView = ({ pipelineId, currentTab }) => {
	const theme = useTheme();
	const dispatch = useDispatch();

	const isRenewals = pipelineId === process.env.REACT_APP_PIPELINE_RENEWALS;
	const isDebtors = pipelineId === process.env.REACT_APP_PIPELINE_DEBTORS;

	const { getFeatureFlags } = useFeatureFlagContext();
	const showDebtors = Boolean(getFeatureFlags('debtors')?.active);

	useEffect(() => {
		dispatch(setSelected([]));
	}, []);

	const isPolicySelectionRenewalsTab = isRenewals && currentTab === 'policies';
	const isInvoiceReportTab = isDebtors && currentTab === 'invoice-report';

	if (isDebtors && !showDebtors) {
		return (
			<Box>
				<Typography>Debtors coming soon</Typography>
			</Box>
		);
	}

	return (
		<Stack
			sx={{
				'& .MuiDataGrid-parentDiv': {
					border: `1px solid ${theme.palette.divider}`,
					borderRadius: '8px',
					backgroundColor: theme.palette.background.paper,
				},
				'& .MuiDataGrid-root': {
					borderRadius: '8px',
				},
				px: 3,
			}}
		>
			{isInvoiceReportTab ? (
				<InsightDebtorsTable displayCheckBoxes={true} />
			) : isDebtors ? (
				<DebtorsTable tab={currentTab} />
			) : isPolicySelectionRenewalsTab ? (
				<InsightPolicyTable />
			) : (
				<DealTable tab={currentTab} pipeline={pipelineId} />
			)}
		</Stack>
	);
};

DealTableView.displayName = 'DealTableView';
